import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import * as Localization from 'expo-localization';

import fr from './locales/fr.json';
import en from './locales/en.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import fr2 from './locales/fr2.json';
import en2 from './locales/en2.json';
import es2 from './locales/es2.json';
import pt2 from './locales/pt2.json';
import fr3 from './locales/fr3.json';
import en3 from './locales/en3.json';
import es3 from './locales/es3.json';
import pt3 from './locales/pt3.json';
import fr4 from './locales/fr4.json';
import en4 from './locales/en4.json';
import es4 from './locales/es4.json';
import pt4 from './locales/pt4.json';

const FALLBACK_LANGUAGE = 'fr';

const frTranslations = {
  ...fr,
  ...fr2,
  ...fr3,
  ...fr4,
};

const enTranslations = {
  ...en,
  ...en2,
  ...en3,
  ...en4,
};

const esTranslations = {
  ...es,
  ...es2,
  ...es3,
  ...es4,
};

const ptTranslations = {
  ...pt,
  ...pt2,
  ...pt3,
  ...pt4,
};

const resources = {
  fr: { translation: frTranslations },
  en: { translation: enTranslations },
  es: { translation: esTranslations },
  pt: { translation: ptTranslations },
};

const supportedLanguages = Object.keys(resources);

function getDeviceLanguage(): string {
  const deviceLocale = Localization.getLocales()[0]?.languageCode;
  if (deviceLocale && supportedLanguages.includes(deviceLocale)) {
    return deviceLocale;
  }
  return FALLBACK_LANGUAGE;
}

i18next
  .use(initReactI18next)
  .init({
    resources,
    lng: getDeviceLanguage(),
    fallbackLng: FALLBACK_LANGUAGE,
    compatibilityJSON: 'v4',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
